module.exports = __webpack_public_path__ + "chevron-up/chevron-up-a172afe360f7782c04c87fe5d2faaf58.png";